import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from '../../../../../hooks/useDashboardState'
import ErrorMessage from '../../../../share/ErrorMessage'
import { InsightViewOption, ResolutionOptions } from '../../../../../enums'
import { GeoRegionsWidget } from '../../types'

const isCityAndPerCapita = (widgetSetting: GeoRegionsWidget) =>
  widgetSetting.viewOption === InsightViewOption.PER_CAPITA &&
  widgetSetting.resolution === ResolutionOptions.CITIES

const PerCapitaNotSupportGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetSetting = useDashboardWidgetSetting<GeoRegionsWidget>(widgetId)
  const { t } = useTranslation()

  if (isCityAndPerCapita(widgetSetting)) {
    return <ErrorMessage>{t('cityUnsupportPercapita')}</ErrorMessage>
  }

  return children
}

export default PerCapitaNotSupportGuard
